import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavigateFunction } from 'react-router-dom';
import { Dispatch } from 'redux';

import { requestLogin } from '../../../api/login/login.actions';

import Login from '../../../components/screens/auth/login/Login';

const LoginContainer = (): ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  const dispatch: Dispatch = useDispatch();

  const handleLogInClick = (email: string, password: string): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to login actions
      requestLogin({
        input: { email, password },
        onSuccess: (): void => navigate('/programmes')
      })
    );
  };

  return <Login handleLogInClick={handleLogInClick} />;
};

export default LoginContainer;
